package com.schoolconnect.app.datasource.network.response

import com.schoolconnect.app.datasource.network.response.FileUploadGrant
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SchoolResponse(
    @SerialName("code")
    val code: String? = null,
    @SerialName("name")
    val name: String? = null,
    @SerialName("board")
    val board: String? = null,
    @SerialName("school_type")
    val schoolType: String? = null,
    @SerialName("medium")
    val medium: String? = null,
    @SerialName("address_line1")
    val addressLine1: String? = null,
    @SerialName("address_line2")
    val addressLine2: String? = null,
    @SerialName("city")
    val city: String? = null,
    @SerialName("district")
    val district: String? = null,
    @SerialName("state")
    val state: String? = null,
    @SerialName("country")
    val country: String? = null,
    @SerialName("pin_code")
    val pinCode: String? = null,
    @SerialName("school_phone")
    val schoolPhone: String? = null,
    @SerialName("school_email")
    val schoolEmail: String? = null,
    @SerialName("primary_contact_name")
    val primaryContactName: String? = null,
    @SerialName("primary_contact_phone")
    val primaryContactPhone: String? = null,
    @SerialName("primary_contact_email")
    val primaryContactEmail: String? = null,
    @SerialName("secondary_contact_name")
    val secondaryContactName: String? = null,
    @SerialName("secondary_contact_phone")
    val secondaryContactPhone: String? = null,
    @SerialName("secondary_contact_email")
    val secondaryContactEmail: String? = null,
    @SerialName("school_logo_url")
    val schoolLogoUrl: String? = null,
    @SerialName("school_description")
    val schoolDescription: String? = null,
    @SerialName("is_active")
    val isActive: Boolean? = null,
    @SerialName("id")
    val id: String? = null,
    @SerialName("created_at")
    val createdAt: String? = null,
    @SerialName("created_by_id")
    val createdById: String? = null,
    @SerialName("created_by_name")
    val createdByName: String? = null,
    @SerialName("updated_at")
    val updatedAt: String? = null,
    @SerialName("updated_by_id")
    val updatedById: String? = null,
    @SerialName("updated_by_name")
    val updatedByName: String? = null,
    @SerialName("student_count")
    val studentCount: Int? = null,
    @SerialName("attachment_file_ids")
    val attachmentFileIds: List<String>? = null,
    @SerialName("attachment_file_urls")
    val attachmentFileUrls: List<String>? = null,
    @SerialName("upload_grant")
    val uploadGrant: FileUploadGrant? = null
)
